'use client';

import { ResponsiveDialogContent, ResponsiveDialogTitle, useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { lazy, Suspense } from 'react';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { Button } from '../ui/button';

// Same contract as ContactModal.id; the form/validation tree is fetched on open.
const CONTACT_MODAL_ID = 'CONTACT_MODAL';
const ContactModal = lazy(() => import('../contact/contact-modal').then(module => ({ default: module.ContactModal })));

// Dialog state uses Immer: keep the mutable React.lazy payload out of its tree.
// The lazy element is created during render, after the store freezes its value.
function DeferredContactModal({ title }: { title: string }) {
  return (
    <Suspense fallback={
      <ResponsiveDialogContent aria-busy="true">
        <ResponsiveDialogTitle>{title}</ResponsiveDialogTitle>
        <div className="flex min-h-32 items-center justify-center" aria-hidden="true"><Spinner /></div>
      </ResponsiveDialogContent>
    }>
      <ContactModal />
    </Suspense>
  );
}

interface OpenModalButtonProps {
  className?: string;
  name: string;
  variant?:
    | 'default'
    | 'destructive'
    | 'accent'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link'
    | 'dark'
    | 'rating'
    | 'default-alt'
    | 'destructive-alt'
    | 'accent-alt';
}

export function OpenModalButton({ className, name, variant = 'default' }: OpenModalButtonProps) {
  const { open } = useResponsiveDialogStore();

  const handleOpen = () => {
    open({
      id: CONTACT_MODAL_ID,
      content: <DeferredContactModal title={name} />,
    });
  };

  return (
    <Button onClick={handleOpen} variant={variant ?? 'default'} className={cn(className)}>
      {name}
    </Button>
  );
}
